export var ModifySubstitutionsSelect = {
  name: "substitution-in",
  component: "MainPanel",
  layout: "main-panel large align-center",
  mode: "visible",
  text: "edit.substitutions",
  showOn: [{ state: "editState", value: "edit-substitutions", operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  doFullCancel: true,
  showDetails: {},
  children: [
    // Select Player
    {
      name: "player-select",
      component: "Substitutions",
      layout: "player-select",
      mode: "visible",
      showOn: [true],
      options: {
        currentEntity: true,
        currentEntityEvent: "edit",
        excludePlay: false,
        excludeFrom: "edit",
        calculateOnCourt: true,
        ignoreFlag: true,
      },
      actionGroups: [
        {
          actions: [
            { action: "nextState", value: null, type: "editState" },
            { action: "nextState", value: null, type: "modify" },
          ],
          conditions: [],
        },
      ],
    },
  ],
};
